import { AdminLayout } from '@/components/layouts'
import { QuizForm } from './QuizForm'

interface Community {
  id: number
  name: string
}

interface NewProps {
  communities: Community[]
  suggested_start_date: string
}

export default function New({ communities, suggested_start_date }: NewProps) {
  return (
    <AdminLayout
      title="Nouveau Quiz Hebdomadaire"
      breadcrumbs={[
        { label: 'Quiz Hebdomadaires', href: '/admin/weekly_quizzes' },
        { label: 'Nouveau Quiz' }
      ]}
    >
      <div className="max-w-3xl">
        <QuizForm
          communities={communities}
          suggestedStartDate={suggested_start_date}
          onSubmit="/admin/weekly_quizzes"
        />
      </div>
    </AdminLayout>
  )
}
